import type { JSX } from "react";
import { Navigate } from "react-router-dom";

/** Ancienne URL admin charroi → module unique Ressources opérationnelles */
export default function AdminCharroiVehiculesRedirect(): JSX.Element {
  return <Navigate to="/admin/ressources-operationnelles" replace />;
}
